export enum OrganizationType {
  NYCBS = "HhwIHO4npKhrxyylkC33",
  MBM = "3GKbZtgpPru1vJGCkxwR",
  MBP = "3GKbZtgpPru1vJGCkxwR",
  CHC = "4BlQ4SsqAVTDgFKApKZr",
  ASTERA = "tPvNbDprUnrXIJlDXyxs",
  DEMO_FACILITY = "57zhkss5CaF9dz90wcpv",
  NYCBS_DRUG_CONFIG = "hwKXreFwPrMpA8Pad7Mr",
  NYCBS_PHARMA = "hwKXreFwPrMpA8Pad7Mr",
  UCBC = "W14MolgUu7OYvX4CFQJn",
  NYCBS_HYD = "Y15ePfa5kC35QiChxXil",
  GENESIS_CARE = "sfmlrFGXYg3aBMdTs4od",
  ASTERA_RADIOLOGY = "rf5w1cNTGVfH9ZAJoLCF",
  MBPCC_RADIOLOGY = "eKxGq3SAYDn3YGeV9r5a",
  /** Sunstate Urology — Firebase organization document ID. */
  SUNSTATE_UROLOGY = "jL5P8oAYMioqeLjR0wbz",
  NYCBS_STAT = "2gsIT00cmhoKc7fYwhnX",
  SUNSTATE = "sfmlrFGXYg3aBMdTs4od",
  /** OCSRI — Medical PA org whose OncoEMR BO row is labeled "FC Hold". */
  OCSRI = "vpxCylNswv08gzkx45bH",
}

export enum FacilityCategory {
  RADIOLOGY = "radiology",
  UROLOGY = "urology",
  MEDONC = "med_onc",
}

/**
 * Orgs that follow the appointment/estimate-based "urology exception" flow
 * instead of the standard medication PA flow. Add an org here to enable the
 * full Sunstate-style behavior package (estimate-value columns/filters,
 * Appointment Type / Procedures labels, shared worklists, no visit data, etc.).
 */
export const exceptionFlowForUrologyOrgs: readonly OrganizationType[] = [
  OrganizationType.SUNSTATE_UROLOGY,
];

/** True when `orgId` is in {@link exceptionFlowForUrologyOrgs}. */
export const isExceptionFlowForUrologyOrg = (orgId?: string | null): boolean =>
  exceptionFlowForUrologyOrgs.includes(orgId as OrganizationType);

/** True when facility `category` is {@link FacilityCategory.RADIOLOGY}. */
export const isExceptionFlowForRadiologyOrg = (
  category?: string | null,
): boolean => category === FacilityCategory.RADIOLOGY;

/** Orgs that work orders through the FC Hold value/comment lifecycle
 * (RISA Working → RISA Completed) instead of the standard BO note flow. */
export const fcHoldOrgs: readonly OrganizationType[] = [
  OrganizationType.OCSRI,
];

/** True when `orgId` is an FC Hold org (OCSRI Medical PA orders). */
export const isFcHoldOrg = (orgId?: string | null): boolean =>
  fcHoldOrgs.includes(orgId as OrganizationType);

/**
 * True when facility `category` is radiology or urology — those orgs skip
 * "Date From" validation on CPT/J-code rows.
 */
export const isFacilityExemptFromDateFromValidation = (
  category?: string | null,
): boolean =>
  isExceptionFlowForRadiologyOrg(category) ||
  category === FacilityCategory.UROLOGY;

/** True when facility `category` is {@link FacilityCategory.MEDONC} or {@link FacilityCategory.RADIOLOGY}. */
export const isMedOncOrRadiologyOrg = (category?: string | null): boolean =>
  category === FacilityCategory.MEDONC ||
  category === FacilityCategory.RADIOLOGY;

/** True when facility `category` is {@link FacilityCategory.UROLOGY} or {@link FacilityCategory.RADIOLOGY}. */
export const isUrologyOrRadiologyOrg = (category?: string | null): boolean =>
  category === FacilityCategory.UROLOGY ||
  category === FacilityCategory.RADIOLOGY;
